import axios from '../AxiosHandler'

export default {
    //Authentication and logout
    LOGIN_USER_MUTATION(state){
        state.loading = true;

        axios.get('/userApi/checkLogin').then(response => {
            state.user      = JSON.parse(response.data);
            state.loading   = false;
        }).catch(err => {console.log(err)});
    },
    LOGOUT_MUTATION(state){
        axios.get('/userApi/logout').then(() => {
            state.user           = null;
            window.location.href = '/mietanzeige-inserieren-login'
        }).catch(err => {console.log(err)});
    },
    //fetch the SPH
    LOCALES_MUTATION(state){
        state.loading = true;
        axios.get('/userApi/locales').then((response) => {
            state.loading = false;
            state.locales = JSON.parse(response.data);
        }).catch(err => {console.log(err)});
    },
    //fetch overview
    OVERVIEW_MUTATION(state){
        axios.get('/objectApi/getUeberblick').then( response => {
            let data            = JSON.parse(response.data);
            state.overview      = {};
            state.overview.active_packets = data.active_packets;
            state.overview.count          = data.count;
            state.overview.count_status   = data.count_status;
            state.overview.count_free     = data.count_free;
            state.overview.count_paid     = data.count_paid;
        }).catch( error => { console.log(error); });
    },
    //fetch dealer info
    IMPRESSUM_MUTATION(state){
        state.loading = true;
        axios.get('/dealerApi/getImpressum').then((response) => {
            state.loading = false;
            let data        = JSON.parse(response.data);
            state.impressum = data;
        }).catch(err => {console.log(err)});
    },
    //fetch objects of the user
    OBJECTS_MUTATION(state, page){
        state.numOfPages     = null;
        state.loading        = true;
        let params           = state.objectsFilters;
        params.page          = page;
        state.lastOpenedPage = page;

        axios.get('/objectApi/getAllObjects', {params}).then(response => {
            let data             = JSON.parse(response.data);
            state.objects        = data.objects;
            state.numOfPages     = Math.ceil(data.count / 10);
            state.loading        = false;
        }).catch(err => {
            console.log(err);
            state.loading = false;
        });
    },
    //fetch object packets of the user
    OBJECT_PACKETS_MUTATION(state){
        state.loading = true;
        axios.get('/objectApi/getAllObjectPackets').then(response => {
            let data             = JSON.parse(response.data);
            state.object_packets = data;
            state.loading        = false;
        }).catch(err => {
            console.log(err);
            state.loading = false;
        });
    },
    //fetch objects of the user
    TINY_OBJECTS_MUTATION(state){
        state.loading        = true;

        axios.get('/objectApi/getAllTinyObjects').then(response => {
            let data                             = JSON.parse(response.data);
            state.tinyObjects.all                = data;

            state.tinyObjects.rental_conditions  = data.filter( object => object.rental_conditions == 1);
            state.tinyObjects.contacts           = data.filter( object => object.contacts == 1);

            state.loading                        = false;
        }).catch(err => {
            console.log(err);
            state.loading = false;
        });
    },
    AVAILABLE_FILTERS_MUTATION(state){
        state.loading = true;
        axios.get('/objectApi/getAvailableFilters').then(response => {
            state.loading = false;
            state.availableFilters = JSON.parse(response.data);
        }).catch(err => { console.log(err); });
    },
    FILTER_MUTATION(state, filter){
        state.objectsFilters[filter.key] = filter.value;
    },
    //get the count of the unread queries
    NOTIFICATIONS_COUNT_MUTATION(state){
        axios.get('/queryApi/getNotificationsCount').then(response => {
            state.notifications_count = Number(response.data);
        }).catch(error => {
            console.log(error);
        });
    },
    //get the count of the unread bewertung
    ASSESSMENT_COUNT_MUTATION(state){
        axios.get('/AssessmentApi/getNewAssessmentsCount').then(response => {
            state.assessment_count = Number(response.data);
        }).catch(error => {
            console.log(error);
        });
    },
    //fetch queries of the user
    QUERIES_MUTATION(state, page){
        state.numOfPagesForRequests     = null;
        state.loading        = true;

        axios.get('/queryApi/getAllQueries?page=' + page).then(response => {
            let data             = JSON.parse(response.data);
            state.queries        = data.queries;
            state.numOfPagesForRequests     = Math.ceil(data.count / 10);
            state.loading        = false;
        }).catch(err => {
            console.log(err);
            state.loading = false;
        });
    },
    //fetch queries of the user based on inserateTitle and inseratenummer
    QUERIES_MUTATION_SEARCH(state, {page , search_query}){
        state.numOfPagesForRequests     = null;
        state.loading        = true;

        axios.get('/queryApi/getAllQueriesByRequestName?page=' + page+'&searchvalue=' + search_query).then(response => {
            let data             = JSON.parse(response.data);
            if(data.queries.length == 0){
                state.loading        = true;
                axios.get('/queryApi/getAllQueriesByCompanyName?page=' + page+'&searchvalue=' + search_query).then(response => {
                    let data             = JSON.parse(response.data);
                    if(data.queries.length == 0){
                        state.loading        = true;
                        axios.get('/queryApi/getAllQueriesByObjectId?page=' + page+'&searchvalue=' + search_query).then(response => {
                            let data             = JSON.parse(response.data);
                            state.queries        = data.queries;
                            state.numOfPagesForRequests     = Math.ceil(data.count / 10);
                            state.loading        = false;
                        }).catch(err => {
                            console.log(err);
                            state.loading = false;
                        });
                    }
                    else
                    {
                        state.queries        = data.queries;
                        state.numOfPagesForRequests     = Math.ceil(data.count / 10);
                        state.loading        = false;
                    }
                }).catch(err => {
                    console.log(err);
                    state.loading = false;
                });
            }
            else
            {
                state.queries        = data.queries;
                state.numOfPagesForRequests     = Math.ceil(data.count / 10);
                state.loading        = false;
            }

        }).catch(err => {
            console.log(err);
            state.loading = false;
        });
    },

    //FETCH THE SEPA MANDATE MISSING INFO
    SEPA_MISSING_INFO_MUTATION(state){
        state.loading = true;

        axios.get('/UserApi/GetSepaInfoStatus').then(response => {
            state.sepaInfoMissing = JSON.parse(response.data);
            state.loading   = false;
        }).catch(err => {console.log(err)});
    },

    //FETCH THE SEPA MANDATE ALL DETAILS
    SEPA_DETAILS_MUTATION(state){
        state.loading = true;

        axios.get('/UserApi/GetSepaInfoDetails').then(response => {
            state.sepaDetails = JSON.parse(response.data);
            state.loading   = false;
        }).catch(err => {console.log(err)});
    }
}
